module.exports = __webpack_public_path__ + "static/media/map-gps-territory.37eea786.svg";